import { Link } from 'react-router-dom'

import { Badge, Fade } from '@mui/material'

import Routes from '@tabeeb/routes'
import { useSelector } from '@tabeeb/store'
import { Caption, Stack, Subheader3, useNavbarContext } from '@collaborate-health/uikit'
import { getMe } from '@tabeeb/modules/account/selectors'
import { getNotificationsCount } from '@tabeeb/modules/notificationsPage/selectors'
import { getIsNotificationsFeatureEnabled } from '@tabeeb/modules/appConfigState/selectors'
import { UserResponse } from '@tabeeb/contracts/main-api/swagger-main-api'

import Notifications from '../Notifications'

import { NavbarUserAvatar, UserAvatarWrapper } from './User.styles'

const User: React.FC = () => {
  const me = useSelector<UserResponse>(getMe)
  const { expanded } = useNavbarContext()

  const notificationsEnabled = useSelector(getIsNotificationsFeatureEnabled)
  const notificationsCount = useSelector<number>(getNotificationsCount)

  return (
    <Stack direction='row' alignItems='center' minHeight={64} padding={1.5} overflow='hidden'>
      <Link to={Routes.userSettings} title='Profile'>
        <UserAvatarWrapper>
          <Badge
            color='accent'
            badgeContent={notificationsCount}
            overlap='circular'
            invisible={expanded || notificationsCount === 0}
            max={100}
          >
            <NavbarUserAvatar user={me} />
          </Badge>
        </UserAvatarWrapper>
      </Link>

      <Fade in={expanded}>
        <Stack minWidth={0} ml={1.25} alignItems='flex-start' overflow='hidden'>
          <Subheader3 title={me.Name!} maxWidth='100%' noWrap>
            {me.Name}
          </Subheader3>
          <Caption title={me.Email!} maxWidth='100%' noWrap>
            {me.Email}
          </Caption>
        </Stack>
      </Fade>
      {notificationsEnabled && <Notifications />}
    </Stack>
  )
}

export default User

